import { useSelector } from 'react-redux';

const Guard = ({ children, selector }) => useSelector(selector) ? children : null;

export default Guard;
